export default __webpack_public_path__ + "static/media/JakeUncropped.538ea0e0.jpeg";